import src from "IMAGE";
export default { src, width: 468, height: 82, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AH9/f3iDg4N5dXV1bWhoaGF6enpxZmZmXnBwcGh0dHRr8o0OS+XLJWcAAAAASUVORK5CYII="};
